<template>
  <div>
    <div class="searchbox">
      <div class="searchbox-line">
        <el-input
            placeholder="请输入内容"
            class="searchInput"
            size="small"
            @input="searchCall()"
            v-model="searchContent">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" size="small" class="searchButton" @click="searchByKeyWord">搜索</el-button>
      </div>
      <transition name="plus-icon">
        <div class="select-box" v-if="showSelectBox===true && searchContent">
          <template v-if="customerList.length">
            <div class="select-box-item" v-for="(item,index) in customerList" :key="index" @click="chooseIphone(item)">{{item.name}}——{{item.phone}}</div>
          </template>
          <div class="select-box-item" v-else>暂无数据</div>
        </div>
      </transition>
    </div>
    <div class="btnsgroups">
      <div :class="{btnsgroupsbtn:true,active:currentIndex===1}" @click="changeCallingType(1)">呼入</div>
      <div :class="{btnsgroupsbtn:true,active:currentIndex===2}" @click="changeCallingType(2)">呼出</div>
    </div>
    <div class="contentBox">
      <div class="callingItem-box" v-if="callingRecordsList.length>0">
        <div class="callingItem" v-for="(item,index) in callingRecordsList" :key="index" @click="chooseRecordItem(item,index)">
          <div class="callingDetail" >
            <div class="img-box">
              <div v-if="item.callType==='呼入'">
                <img  v-if="getAnswerStatus(item.status)"  src="../../assets/images/callin-answered.png" alt="">
                <img  v-else-if="getUnAnswerStatus(item.status)" src="../../assets/images/callin-noanswer.png" alt="">
                <img  v-else src="../../assets/images/callin-default.png" alt="">
              </div>
              <div v-if="item.callType==='预览外呼' || item.callType==='直接外呼' || item.callType==='主叫外呼'">
                <img v-if="getAnswerStatus(item.status)" src="../../assets/images/callout-answered.png" alt="">
                <img v-else-if="getUnAnswerStatus(item.status)" src="../../assets/images/callout-noanswer.png" alt="">
                <img  v-else src="../../assets/images/callin-default.png" alt="">
              </div>
              <!--              <img  src="../../assets/images/callout-noanswer.png" alt="">-->
            </div>
            <div class="customerInfo">
              <div class="customerName">
                <span>{{item.name}}</span>
                <span class="customerTime">{{timeMode(item.startTime*1000,'/').curData}}</span>
<!--                <img class="edit-calling-img" src="../../assets/images/callImg.png" alt="" @click.stop="editRecords(item.name, item.customerNumber)">-->
              </div>
              <span class="customerTel">{{item.customerNumber}}（{{item.customerProvince}}/{{item.customerCity}}）</span>
            </div>
          </div>
          <div class="resultType" v-if="!item.showButton">
            <span v-if="item.callType==='呼入' && item.status ==='座席未接听'" style="color: #F56C6C">座席未接听</span>
            <span v-else-if="(item.callType==='预览外呼' || item.callType==='直接外呼') && item.status==='客户未接听'" style="color: #F56C6C">用户未接听</span>
            <span v-else-if="(item.callType==='预览外呼' || item.callType==='直接外呼') && item.status==='座席未接听'" style="color: #F56C6C">座席未接听</span>
            <span v-else-if="item.status==='双方接听' || item.status==='座席接听'" style="color:  #4DD266" >双方接听</span>
            <span v-else style="color:#4DD266">系统应答</span>
          </div>
          <div v-if="item.showButton">
            <img src="../../assets/images/callImg.png" alt="" @click.stop="telNumber(item)">
          </div>
        </div>
      </div>
      <div v-else style="color: #606266;text-align: center">暂无通话记录</div>
    </div>
    <div class="pagination-container">
      <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :total="total">
      </el-pagination>
    </div>
    <!-- 呼叫中心 -->
<!--    <el-dialog-->
<!--        title="关联用户"-->
<!--        :visible.sync="dialogRelateUser"-->
<!--        width="410px"-->
<!--        :modal="false"-->
<!--        class="dialogVisibleCallCenterBox"-->
<!--    >-->
<!--      &lt;!&ndash;      <div class="phoneStyle">&ndash;&gt;-->
<!--      &lt;!&ndash;        <span class="phoneBox">电话类型</span>&ndash;&gt;-->
<!--      &lt;!&ndash;        <el-radio v-model="phoneRadio" label="1" class="phoneRadio"&ndash;&gt;-->
<!--      &lt;!&ndash;        >普通电话</el-radio&ndash;&gt;-->
<!--      &lt;!&ndash;        >&ndash;&gt;-->
<!--      &lt;!&ndash;        <el-radio v-model="phoneRadio" label="2" class="phoneRadio"&ndash;&gt;-->
<!--      &lt;!&ndash;        >IP话机</el-radio&ndash;&gt;-->
<!--      &lt;!&ndash;        >&ndash;&gt;-->
<!--      &lt;!&ndash;        <el-radio v-model="phoneRadio" label="3" class="phoneRadio"&ndash;&gt;-->
<!--      &lt;!&ndash;        >软电话</el-radio&ndash;&gt;-->
<!--      &lt;!&ndash;        >&ndash;&gt;-->
<!--      &lt;!&ndash;      </div>&ndash;&gt;-->
<!--      <el-form :model="form" class="demo-form-inline" label-position="right" label-width="70px" >-->
<!--        <el-form-item label="关联患者">-->
<!--          <el-cascader-->
<!--              v-model="value"-->
<!--              :options="options"-->
<!--              filterable-->
<!--              @change="handleChange"></el-cascader>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="用户姓名">-->
<!--          <el-input v-model="form.username" placeholder="关联患者"></el-input>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--      <span slot="footer" class="dialog-footer">-->
<!--        <el-button @click="dialogRelateUser=false" class="cancel">取消</el-button>-->
<!--        <el-button type="primary" @click="sureBtn()" class="sureBtnBox"-->
<!--        >确认</el-button-->
<!--        >-->
<!--      </span>-->
<!--    </el-dialog>-->
    <!-- 会员列表呼叫、解绑 -->
    <el-dialog
        :visible.sync="callAndUnbundle"
        width="360px"
        :show-close="false"
        :modal="false"
        class="callAndUnbundleBox"
    >
      <div class="callAndUnbundleCon">
        <div class="title">是否呼叫【{{ callName }}】？</div>
        <div class="associatedBtn">
          <div class="associatedCancel" @click="callAndUnbundle=false">
            取消
          </div>
          <div class="associatedSure" @click="callAndUnbundleSure()">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {timeMode} from "../../tools/utils";
export default {
  data(){
    return{
      timeMode,
      currentIndex:1,
      showSelectBox:false,
      form:{
        patient:"",
        username:""
      },
      value:"",
      searchContent:"",
      currentPage:1,
      total:10,
      callingRecordsList:[],
      options:[],
      todayTime:{
        startTime:new Date(new Date().setHours(0, 0, 0, 0)).getTime()/1000  ,
        endTime: Math.floor(new Date(new Date().setHours(23,59,59,999)).getTime()/1000)
      },
      callAndUnbundle:false,
      userName: "",
      userPhone: "",
      callName: "",
      callPhone: "",
      customerList:[],
      customerInfo:""
    }
  },
  created() {
    this.searchCallingRecords()

  },
  methods:{
    chooseRecordItem(item,index){
      item.showButton=!item.showButton
      this.callingRecordsList.forEach((ite,_index)=>{
        if (index!==_index){
          ite.showButton=false
        }
      })
      this.$emit('updateDetail',item,this.currentIndex)

    },
    handleChange(){
      console.log(4444)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val
      this.searchCallingRecords()
    },
    //判断接听
    getAnswerStatus(str){
      if (str==='座席接听' || str==='双方接听'){
        return true
      }else {
        return  false
      }
    },
    //判断未接听
    getUnAnswerStatus(str){
      return str.includes("未接听")
    },
    // 通话呼叫、编辑弹窗确认
    callAndUnbundleSure() {
      ClinkAgent.previewOutcall({ tel: this.callPhone });
      this.callAndUnbundle = false;
    },
    telNumber(item){

      if(this.$store.state.calling.isLogin){
        console.log(item, "打电话");
        this.callName = item.name;
        this.callPhone = item.customerNumber;
        this.callAndUnbundle = true;
      }else {
        this.$message.warning({
          message:'请先登录呼叫中心!',
          duration:1000
        })
      }


    },
    changeCallingType(index){
      console.log('切换输入输出类容')
      this.currentIndex=index
      this.currentPage=1
      this.searchCallingRecords()
    },
    //获取所有通话记录
    searchCallingRecords(){
      const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
      let params = {
            cno:userInfo.cno,
            keyword:this.customerInfo.phone,
            startTime:this.todayTime.startTime,
            endTime:this.todayTime.endTime,
            status: 0,//0全部 1: 座席接听 2: 已呼叫座席，座席未接听
            pageSize:10,
            page:this.currentPage,
            type:this.currentIndex
      }
      this.$http.getCallingRecords(params).then(res=>{
        console.log(res,'=============通话记录==============')
        this.$emit('updateDetail',res.result.data.callList[0],this.currentIndex)
        if (res.result.data.callList.length>0){
          res.result.data.callList.forEach(item=>{
            item.showButton=false
          })
          this.callingRecordsList = res.result.data.callList
          this.total =res.result.data.totalCount
        }else {
          this.callingRecordsList = []

        }
      })

    },
    chooseIphone(val){
      this.showSelectBox=false
      this.customerInfo=val
      this.searchCallingRecords()
    },
    searchCall() {
      if (!this.searchContent) {
        this.customerInfo=''
        this.searchCallingRecords()
      };
    },
    //通过姓名和手机号搜索符合要求的患者列表
    searchByKeyWord(){
      let params = {
        keyword:this.searchContent
      }
      this.$http.getCallingPatientsList(params).then(res=>{
        console.log(res,'=======================')
        this.showSelectBox=true
        this.customerList = res.result.data
      }).catch(err=>{
        this.$message.warning(`搜索失败:${err.msg}`)
      })
    }
  }
}
</script>

<style scoped lang="less">
.btnsgroups{
  display: flex;
  cursor: default;
  .btnsgroupsbtn{
    margin-left: 16px;
    width: 76px;
    height: 36px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #DCDEE0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;

  }
  .active{
    background: #EFF7FF;
    border: 1px solid #4FACFF;
    color: #4FACFF;
  }
}
.contentBox{
  //height: calc(100% - 300px)!important;
  padding: 10px 42px;
  height: 600px !important;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  // 滚动条的轨道的两端按钮，允许通过点击微调小方块的位置。
  &::-webkit-scrollbar-button {
    display: none;
  }
  // 滚动条的轨道（里面装有Thumb）
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  // 滚动条的轨道（里面装有Thumb）
  &::-webkit-scrollbar-track-piece {
    background-color: transparent;
  }
  // 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
  &::-webkit-scrollbar-thumb {
    background: rgba(144, 147, 153, 0.3);
    cursor: pointer;
    border-radius: 4px;
  }
  // 边角，即两个滚动条的交汇处
  &::-webkit-scrollbar-corner {
    display: none;
  }
  // 两个滚动条的交汇处上用于通过拖动调整元素大小的小控件
  &::-webkit-resizer {
    display: none;
  }
  .callingItem-box{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .callingItem{
      font-family: PingFangSC-Regular, PingFang SC !important;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0px;
      border-bottom: 1px solid #C8C9CC;
      box-sizing: border-box;
      .callingDetail{
        display: flex;
        align-items: center;
        .customerInfo{
          margin-left: 15px;
          text-align: left;
          color: #303133;
          .customerName{
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;
            margin-bottom: 4px;
          }
          .customerTel{
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
          }
          .customerTime{
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
            margin-left: 7px;
          }
        }
      }
      .type-box{
        font-size: 12px;
      }

    }
  }
}
.pagination-container{
  .el-pagination{
    margin-top: 16px;
  }
}
.searchbox{
  display: flex;
  flex-direction: column;
  position: relative;
  .searchbox-line{
    width: 100%;
    display: flex;
  }
  .select-box{
    overflow: auto;
    width: 95%;
    padding: 10px;
    background-color: #fff;
    box-sizing: border-box;
    max-height: 200px;
    position: absolute;
    top: 45px;
    border-radius: 4px;
    border: 1px solid #eeeeee;
    .select-box-item{
      margin-bottom: 10px;
      font-size: 14px;
      cursor: default;
    }
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    // 滚动条的轨道的两端按钮，允许通过点击微调小方块的位置。
    &::-webkit-scrollbar-button {
      display: none;
    }
    // 滚动条的轨道（里面装有Thumb）
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    // 滚动条的轨道（里面装有Thumb）
    &::-webkit-scrollbar-track-piece {
      background-color: transparent;
    }
    // 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
    &::-webkit-scrollbar-thumb {
      background: rgba(144, 147, 153, 0.3);
      cursor: pointer;
      border-radius: 4px;
    }
    // 边角，即两个滚动条的交汇处
    &::-webkit-scrollbar-corner {
      display: none;
    }
    // 两个滚动条的交汇处上用于通过拖动调整元素大小的小控件
    &::-webkit-resizer {
      display: none;
    }
  }
}
// 会员列表呼叫、解绑
/deep/.callAndUnbundleBox {
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 30px;
    .callAndUnbundleCon {
      .title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #606266;
        text-align: center  ;

      }
      .associatedBtn {
        display: flex;
        justify-content: center;
        margin-top: 25px;
        .associatedCancel {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #303133;
          width: 120px;
          height: 40px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          box-sizing: border-box;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .associatedSure {
          width: 120px;
          height: 40px;
          background: #4facff;
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 20px;
        }
      }
    }
  }
}
.plus-icon-enter-active{
  transition: opacity .2s;
}
.plus-icon-enter{
  opacity: 0;
}
.plus-icon-leave-active{
  transition: opacity .2s;
}
.plus-icon-leave-to{
  opacity: 0;
}
</style>
